module.exports = __webpack_public_path__ + "media/images/rank_01-a0e18ff3121f1fdfdb366a030a071539.png";